import { PlusOutlined } from "@ant-design/icons";
import {
  List,
  message,
  Button,
  Layout,
  Space,
  Avatar,
  Tag,
  DatePicker,
  Select,
} from "antd";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ApiManager, Locale } from "../../utils";
import { getUserInfo } from "../../utils/redux/reducers/User";
import Base from "../Base";

const api = ApiManager.getInstance();
const i18n = Locale.getInstance();
const base = Base.getInstance();

function EditorsChoiceList() {
  const fetching = useRef(false);
  const fetchData = useRef(() => {});
  const user = useSelector((state) => getUserInfo(state));
  const router = useHistory();
  const [loading, setLoading] = useState(false);
  const [data, setListData] = useState([]);
  const [statusFilter, setStatusFilter] = useState(undefined);
  const [dateRange, setDateRange] = useState(null);

  fetchData.current = async () => {
    if (!user.token) return;
    if (fetching.current) return;
    fetching.current = true;
    setLoading(true);
    const apiUrl = api.article.editorsChoiceList;
    const query = {};
    if (statusFilter !== undefined && statusFilter !== null) {
      query.status = statusFilter;
    }
    if (dateRange && dateRange[0] && dateRange[1]) {
      query.from_date = dateRange[0].format("YYYY-MM-DD");
      query.to_date = dateRange[1].format("YYYY-MM-DD");
    }
    try {
      const res = await apiUrl.run({ token: user.token, query });
      if (res.result) {
        setListData(res.data || []);
      } else {
        message.warning(res.message);
      }
    } catch (error) {
      base.handleApiError(apiUrl, error);
    } finally {
      fetching.current = false;
      setLoading(false);
    }
  };

  function onDeleteItem(id) {
    base.showModal(
      i18n.t("sales.deleteWarning"),
      Base.Modal.confirm,
      async () => {
        const apiUrl = api.article.editorsChoiceDelete;
        try {
          const res = await apiUrl.run({
            token: user.token,
            path: { id },
          });
          if (res.result) {
            fetchData.current();
          } else {
            base.showMessage(res.message, Base.Message.warning);
          }
        } catch (error) {
          base.handleApiError(apiUrl, error);
        }
      }
    );
  }

  useEffect(() => {
    fetchData.current();
  }, [statusFilter, dateRange]);

  return (
    <Layout>
      <Layout.Content>
        <List
          header={
            <Space wrap size={10}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  router.push({
                    pathname: "/main/article/editors-choice-edit",
                  });
                }}
              >
                {i18n.t("article.editorsChoiceAdd")}
              </Button>
              <Select
                allowClear
                placeholder={i18n.t("sales.status")}
                style={{ width: 140 }}
                value={statusFilter}
                onChange={setStatusFilter}
                options={[
                  { value: 1, label: i18n.t("article.opened") },
                  { value: 0, label: i18n.t("article.closed") },
                ]}
              />
              <DatePicker.RangePicker
                value={dateRange}
                onChange={setDateRange}
              />
            </Space>
          }
          bordered
          size="large"
          style={{ backgroundColor: "#fff" }}
          loading={loading}
          dataSource={data}
          rowKey={(record) => `ec-${record.id}`}
          renderItem={(item) => {
            const showDate = item.show_on_date
              ? dayjs(item.show_on_date).format("YYYY-MM-DD")
              : "";
            const articleName = item.article
              ? i18n.getPropNameByLocale(item.article, "name")
              : `Article #${item.article_id}`;
            const cover =
              i18n.getPropNameByLocale(item, "image") ||
              (item.article
                ? i18n.getPropNameByLocale(item.article, "image")
                : null);
            return (
              <List.Item
                style={{
                  backgroundColor: item.status === 1 ? "#ffffff" : "#f1f1f1",
                }}
                actions={[
                  <Button
                    key="edit"
                    type="link"
                    onClick={() => {
                      router.push({
                        pathname: "/main/article/editors-choice-edit",
                        state: { data: item },
                      });
                    }}
                  >
                    {i18n.t("product.productItem.actionEdit")}
                  </Button>,
                  <Button
                    key="delete"
                    type="link"
                    danger
                    onClick={() => onDeleteItem(item.id)}
                  >
                    {i18n.t("sales.activity.delete")}
                  </Button>,
                ]}
              >
                <List.Item.Meta
                  avatar={
                    <Avatar src={cover} size="large" shape="square" />
                  }
                  title={
                    <Space>
                      <span>{showDate}</span>
                      <Tag color={item.status === 1 ? "green" : "default"}>
                        {item.status === 1
                          ? i18n.t("article.opened")
                          : i18n.t("article.closed")}
                      </Tag>
                    </Space>
                  }
                  description={
                    <div>
                      <div>{articleName}</div>
                      <div>
                        {i18n.getPropNameByLocale(item, "comment") || ""}
                      </div>
                    </div>
                  }
                />
              </List.Item>
            );
          }}
        />
      </Layout.Content>
    </Layout>
  );
}

export default EditorsChoiceList;
